import * as Cookie from 'tiny-cookie'

export default {
  namespaced: true,

  state: {
    customer: null,
  },

  mutations: {
    setCustomer (state, customer) {
      state.customer = customer
    }
  },

  actions: {
    async syncCustomer (context) {
      const subdomain = context.rootState.portal.subdomain
      const { data } = await this._vm.$api.get(`portal/${subdomain}/auth/customer/me`)
      context.commit('setCustomer', data.customer)
    },

    async logout (context) {
      await this._vm.$api.post('auth/logout')
      Cookie.remove('customer_token')
      context.commit('setCustomer', null)
    }
  }
}